module.exports = __webpack_public_path__ + "media/images/emblems/Blason_Romainmotier-Envy-0e3af9d827c17049f9e730abbdd94e9e.svg";